import type { OwaDate } from 'owa-datetime';

export interface OnDateUpdatedAgendaListPayload {
    type: AgendaListInteraction.OnDateUpdated;
    date: OwaDate;
}
export enum AgendaListInteraction {
    OnDateUpdated,
}

export type AgendaListPayload = OnDateUpdatedAgendaListPayload;

export function isOnDateUpdatedAgendaListPayload(
    payload: AgendaListPayload
): payload is OnDateUpdatedAgendaListPayload {
    return payload && payload.type === AgendaListInteraction.OnDateUpdated;
}
